import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
export function useImportJobRouteParams() {
    var _a = useParams(), importJobId = _a.importJobId, replaceImportJobId = _a.replaceImportJobId;
    var parsedImportJobId = Number.parseInt(importJobId !== null && importJobId !== void 0 ? importJobId : '');
    var parsedReplaceImportJobId = Number.parseInt(replaceImportJobId !== null && replaceImportJobId !== void 0 ? replaceImportJobId : '');
    return useMemo(function () { return ({
        importJobId: Number.isNaN(parsedImportJobId) ? null : parsedImportJobId,
        replaceImportJobId: Number.isNaN(parsedReplaceImportJobId) ? null : parsedReplaceImportJobId,
    }); }, [parsedImportJobId, parsedReplaceImportJobId]);
}
